/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CompetenceCompetenceidLangsId202,
  PutApiV1CompetenceCompetenceidLangsId400,
  PutApiV1CompetenceCompetenceidLangsId401,
  PutApiV1CompetenceCompetenceidLangsId404,
  PutApiV1CompetenceCompetenceidLangsId409,
  PutApiV1CompetenceCompetenceidLangsId500,
  PutApiV1CompetenceCompetenceidLangsIdMutationRequest,
  PutApiV1CompetenceCompetenceidLangsIdMutationResponse,
  PutApiV1CompetenceCompetenceidLangsIdPathParams,
} from "../../types/competenceIdiomasController/PutApiV1CompetenceCompetenceidLangsId.ts";
import { competenceLangViewModelSchema } from "../competenceLangViewModelSchema.ts";
import { updateCompetenceLangRequestViewModelSchema } from "../updateCompetenceLangRequestViewModelSchema.ts";

export const putApiV1CompetenceCompetenceidLangsIdPathParamsSchema = z.object({
  competenceId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1CompetenceCompetenceidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1CompetenceCompetenceidLangsId202Schema = z.lazy(
  () => competenceLangViewModelSchema,
) as unknown as ToZod<PutApiV1CompetenceCompetenceidLangsId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CompetenceCompetenceidLangsId400Schema =
  z.any() as unknown as ToZod<PutApiV1CompetenceCompetenceidLangsId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CompetenceCompetenceidLangsId401Schema =
  z.any() as unknown as ToZod<PutApiV1CompetenceCompetenceidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1CompetenceCompetenceidLangsId404Schema =
  z.any() as unknown as ToZod<PutApiV1CompetenceCompetenceidLangsId404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const putApiV1CompetenceCompetenceidLangsId409Schema =
  z.any() as unknown as ToZod<PutApiV1CompetenceCompetenceidLangsId409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CompetenceCompetenceidLangsId500Schema =
  z.any() as unknown as ToZod<PutApiV1CompetenceCompetenceidLangsId500>;

export const putApiV1CompetenceCompetenceidLangsIdMutationRequestSchema =
  z.lazy(
    () => updateCompetenceLangRequestViewModelSchema,
  ) as unknown as ToZod<PutApiV1CompetenceCompetenceidLangsIdMutationRequest>;

export const putApiV1CompetenceCompetenceidLangsIdMutationResponseSchema =
  z.lazy(
    () => putApiV1CompetenceCompetenceidLangsId202Schema,
  ) as unknown as ToZod<PutApiV1CompetenceCompetenceidLangsIdMutationResponse>;
